import React, { useState } from 'react'
import { Form, Link, usePage } from '@inertiajs/react'
import AuthLayout from '../../components/AuthLayout'

export default function ForgotPassword() {
  const { errors } = usePage().props
  const [processing, setProcessing] = useState(false)

  const userErrors = errors?.user || errors || {}

  return (
    <AuthLayout>
      <div className="text-center text-white">
        <h2 className="text-2xl font-bold mb-2">Esqueceu sua senha?</h2>
        <p className="text-sm mb-6 text-gray-200">
          Digite seu e-mail e enviaremos instrucoes para recuperar sua senha.
        </p>

        <Form
          action="/users/password"
          method="post"
          options={{ forceFormData: true }}
          onStart={() => setProcessing(true)}
          onFinish={() => setProcessing(false)}
        >
          <div className="mb-6">
            <input
              type="email"
              name="user[email]"
              placeholder="Digite seu e-mail"
              className="w-full h-12 px-4 rounded-lg bg-white/65 text-gray-800 placeholder-gray-500 border-0 focus:ring-2 focus:ring-brand-light"
              autoFocus
              autoComplete="email"
            />
            {userErrors.email && (
              <div className="mt-1 text-red-300 text-sm text-left">{userErrors.email}</div>
            )}
          </div>

          <button
            type="submit"
            disabled={processing}
            className="w-full h-12 bg-brand-light hover:bg-white hover:text-brand-dark text-white font-medium rounded-lg transition-colors disabled:opacity-50 mb-6"
          >
            {processing ? 'Enviando...' : 'Enviar instrucoes'}
          </button>

          <div className="space-y-2 text-sm">
            <Link href="/users/sign_in" className="block hover:underline">
              Voltar para o login
            </Link>
            <Link href="/users/sign_up" className="block hover:underline">
              Ainda nao e cadastrado? criar conta
            </Link>
          </div>
        </Form>
      </div>
    </AuthLayout>
  )
}
